const VersionForm = ({ form, setForm }) => {
  return (
    <div className="grid gap-3">
      <div>
        <label className="mb-1 block text-xs md:text-sm font-semibold text-gray-900">
          Platform Name
        </label>
        <input
          type="text"
          value={form?.platform ?? ""}
          onChange={(e) => setForm({ ...form, platform: e.target.value })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-xs md:text-sm text-gray-900 placeholder-gray-400 focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
          placeholder="e.g. iOS, Android, Web"
        />
      </div>

      <div>
        <label className="mb-1 block text-xs md:text-sm font-semibold text-gray-900">
          Version
        </label>
        <input
          type="text"
          value={form?.version ?? ""}
          onChange={(e) => setForm({ ...form, version: e.target.value })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-xs md:text-sm text-gray-900 placeholder-gray-400 focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500"
          placeholder="e.g. 3.3.9"
        />
      </div>
    </div>
  );
};

export default VersionForm;
